import { ObservableArray, View } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { DistinguishingDetailDefinitionViewModel } from "../distinguishingDetailDefinition/distinguishingDetailDefinition-viewModel";
import { AccountDefinitionViewModel, SingleAccount } from "./accountDefinition-viewModel"

export class AccountDefinitionView extends View<AccountDefinitionViewModel>{
    GetViewUniqueId(): string {
        return "V-36AE389B-33C6-49EC-8803-CC4DBDD20499"
    }
    loadHtml(): string {
        let element = require('./accountDefinition.html').default;
        let style = require('./accountDefinition.less');
        return element;
    }
    constructor() {
       super();
    }

    public set detailDefinition(v: DistinguishingDetailDefinitionViewModel) { this._detailDefinition = v; } public get detailDefinition(): DistinguishingDetailDefinitionViewModel { return this._detailDefinition;} private _detailDefinition: DistinguishingDetailDefinitionViewModel;
    public set rootAccounts(v: ObservableArray<SingleAccount>) { this._rootAccounts = v; } public get rootAccounts(): ObservableArray<SingleAccount> { return this._rootAccounts;} private _rootAccounts: ObservableArray<SingleAccount>;
    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup;} private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup;} private _popup: IPopup;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;

    addAccount(){
        this.dataContext.addAccount();
    }

    save(){
        this.dataContext.save();
    }
}
